<template>
  <header class="page-header">
    <h1 :class="['page-title', titleClass]">{{ title }}</h1>
    <p :class="['page-subtitle', subtitleClass]">
      <slot>{{ subtitle }}</slot>
    </p>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'typo-headline-4'
    },
    subtitleClass: {
      type: String,
      default: 'typo-body-1'
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-title {
  color: var(--color-primary);
  margin-bottom: 12px;
  font-size: 2.125rem;
  font-weight: 500;
  line-height: 1.2;
}

.page-subtitle {
  color: var(--color-text-secondary);
  max-width: 600px;
  margin: 0 auto 20px auto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 1.75rem;
  }
  
  .page-subtitle {
    font-size: 0.9rem;
  }
}
</style> 